import React from "react";
import { Helmet } from "react-helmet-async";
import { BUSINESS, absoluteUrl } from "../seo/siteConfig";

interface SeoProps {
  /** Full <title> text, written per page. Aim for under ~60 characters. */
  title: string;
  /** Meta description. Aim for 140-160 characters. */
  description: string;
  /** Route path this page lives at, used for the canonical and og:url. */
  path: string;
  /** Absolute URL of the share image. Falls back to the logo. */
  image?: string;
  noIndex?: boolean;
  /** JSON-LD objects to emit for this page. */
  schema?: object[];
}

const Seo: React.FC<SeoProps> = ({
  title,
  description,
  path,
  image = BUSINESS.logo,
  noIndex = false,
  schema = [],
}) => {
  const url = absoluteUrl(path);

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={BUSINESS.name} />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schema.map((entry, index) => (
        <script type="application/ld+json" key={index}>
          {JSON.stringify(entry)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
